import React from "react"
import { NextSeo } from "next-seo"
import { observer } from "mobx-react"

import Sumo from "~/components/_integrations/Sumo"
import Wisepops from "~/components/_integrations/Wisepops"
import Landing from "~/components/divorce/lookup/landing"
import { FETCHER_CITY_STATES } from "~/utilities/constants"
import transfer from "~/utilities/transfer"

const FALLBACK_FETCHER_STATE = "/divorce/lookup/new-york"

const DivorceLookupLandingPage = () => (
  <>
    <NextSeo title="Lookup Divorces Cases | WinIt" />

    <Landing />

    <Sumo />
    <Wisepops />
  </>
)

DivorceLookupLandingPage.getInitialProps = async ({ store, query, res }) => {
  const fetcherInfo = FETCHER_CITY_STATES.divorce[query.state]
  
  if (!fetcherInfo) {
    transfer(res, FALLBACK_FETCHER_STATE)

    return {}
  }

  store.divorceLookup.setFetcherState(fetcherInfo.fetcherState)
  store.divorceLookup.setFetcherName(fetcherInfo.fetcherName)

  // TODO Move WinIt Law and States MST actions and properties to new stores
  await store.trafficLookup.loadTrafficStates()
  store.trafficLookup.setIsStateAffiliatedWithWinitLaw(fetcherInfo.fetcherState)

  return {
    statusCode: res?.statusCode || 200
  }
}

export default observer(DivorceLookupLandingPage)
